export default (form) => {
    const regExp = {
        tel: RegExp("\\+[0-9]{3}\\(([0-9]{2})\\)([0-9]{3})-([0-9]{2})-([0-9]{2})"),
        email: RegExp('[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?'),
        name: RegExp('[a-zA-Z][a-zA-Z-_ ]{2,50}|[а-яА-Я][а-яА-Я-_ ]{2,50}'),
        address: RegExp('[а-яА-Яa-zA-Z][а-яА-Яa-zA-Z-1-9.#_]{2,50}'),
        message: RegExp('[a-zA-Z][a-zA-Z-_ ]{2,50}|[а-яА-Я][а-яА-Я-_ ]{2,50}'),
    }
    

    function MESSAGE(input, message) {
        let createEl = document.createElement("p");
        createEl.innerHTML =  '<span> ! </span>' + message;
        createEl.classList.add('error');
        if(!input.parentElement.querySelector('.error')){
            input.parentElement.append(createEl);
        }
        let errors = document.querySelector('.error');
        errors.scrollIntoView({
            block: "center",
            behavior: "smooth"
        })
        setTimeout(() => {
            input.parentElement.style.position = "relative";
            createEl.classList.add('active');
        }, 1);
        setTimeout(() => {
            createEl.remove();
        }, 2000);
        
    }
    let result = true;
    let inputs = form.querySelectorAll('input')
    inputs.forEach((item) => {
       switch (item.getAttribute('type') || item.getAttribute('name')) {
            case ("text"):
                if (!regExp['name'].test(item.value)){
                    if(item.value.length === 0){
                        MESSAGE(item, 'Заполните поле');
                    }else{
                        MESSAGE(item, 'Введите корректно');
                    }
                    return result = false;
                }
                break
            case ("email"):
                if (!regExp['email'].test(item.value)){
                    if(item.value.length === 0){
                        MESSAGE(item, 'Заполните поле');
                    }else{
                        MESSAGE(item, 'Введите корректно Email');
                    }
                    return result = false;
                }
                break;
            case ('tel'):
                if (!regExp['tel'].test(item.value.replace(/\s/g, ""))){
                    if(item.value.length === 0){
                        MESSAGE(item, 'Заполните поле');
                    }else{
                        MESSAGE(item, 'Введите телефон в формате +375(00)000-00-00');
                    }
                    return result = false;
                }
                break;
            case ('address'):
                if (!regExp['address'].test(item.value)){
                    if(item.value.length === 0){
                        MESSAGE(item, 'Заполните поле');
                    }else{
                        MESSAGE(item, 'Введите корректно адрес');
                    }
                    return result = false;
                }
                break;
            case ('agreement'):
                if (!item.checked) {
                    if(item.value.length === 0){
                        MESSAGE(item, 'Заполните поле');
                    }else{
                        MESSAGE(item, 'Требуется соглашение с политикой конфиденциальности!');
                    }
                    return result = false;
                }
                break;
            case('password'):
                if(!item.value){
                    MESSAGE(item, 'Заполните поле');
                    return result = false;
                }
            default:
                return result = true;
        }
    });
    let textarea = form.querySelector('textarea')
    if(textarea && !textarea.value){
        MESSAGE(textarea, 'Заполните поле');
        return result = false;
    }
    return result
}